"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = exports.TimePicker = void 0;
var react_1 = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
function dateToHMAM(d) {
    var hours24 = d.getHours();
    var minutes = d.getMinutes();
    var hours12 = hours24 % 12;
    if (hours12 === 0)
        hours12 = 12;
    var isAM = hours24 < 12;
    return { hours: hours12, minutes: minutes, isAM: isAM };
}
function setHMAM(baseDate, hours12, minutes, isAM) {
    var d = new Date(baseDate);
    var hours24 = hours12;
    if (isAM && hours12 === 12) {
        hours24 = 0; // 12 AM => 0
    }
    else if (!isAM && hours12 !== 12) {
        hours24 = hours12 + 12;
    }
    d.setHours(hours24, minutes, 0, 0);
    return d;
}
function TimePicker(props) {
    var onDateChange = props.onDateChange, date = props.date, minDate = props.minDate, maxDate = props.maxDate;
    // We use a local date to avoid rerender on each automatic increase/decrease when user holds the button.
    var _a = __read((0, react_1.useState)(function () {
        var initial = date !== null && date !== void 0 ? date : new Date();
        return clampDate(initial, minDate, maxDate);
    }), 2), localDate = _a[0], setLocalDate = _a[1];
    // Press-and-hold refs
    var hoursIncrementRef = (0, react_1.useRef)(null);
    var hoursDecrementRef = (0, react_1.useRef)(null);
    var minutesIncrementRef = (0, react_1.useRef)(null);
    var minutesDecrementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        // If the parent changes the date prop to a *different* day/time,
        // update our localDate so they're in sync.
        setLocalDate(clampDate(date !== null && date !== void 0 ? date : new Date(), minDate, maxDate));
    }, [date, minDate, maxDate]);
    (0, react_1.useEffect)(function () {
        return function () {
            [hoursIncrementRef, hoursDecrementRef, minutesIncrementRef, minutesDecrementRef].forEach(function (ref) {
                if (ref.current)
                    clearInterval(ref.current);
            });
        };
    }, []);
    // Derive display fields
    var _b = dateToHMAM(localDate), hours = _b.hours, minutes = _b.minutes, isAM = _b.isAM;
    // Final sync on release if day didn’t change earlier
    var syncToParent = function () {
        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(localDate);
    };
    function startHolding(ref, action) {
        action(); // do once
        // eslint-disable-next-line no-param-reassign
        ref.current = window.setInterval(function () {
            action();
        }, 200);
    }
    function stopHolding(ref) {
        if (ref.current) {
            clearInterval(ref.current);
            // eslint-disable-next-line no-param-reassign
            ref.current = null;
        }
        syncToParent();
    }
    function incrementHours() {
        setLocalDate(function (oldDate) {
            var oldDay = oldDate.getDate();
            var _a = dateToHMAM(oldDate), oldH = _a.hours, oldM = _a.minutes, oldAM = _a.isAM;
            var newHours = oldH + 1;
            var newIsAM = oldAM;
            if (newHours > 12) {
                newHours = 1;
            }
            var newDate = new Date(oldDate);
            // 11 -> 12 => flip AM/PM => possibly next day
            if (oldH === 11 && newHours === 12) {
                newIsAM = !oldAM;
                if (!oldAM) {
                    newDate.setDate(newDate.getDate() + 1);
                }
            }
            newDate = setHMAM(newDate, newHours, oldM, newIsAM);
            newDate = clampDate(newDate, minDate, maxDate);
            // Day changed => immediate parent update
            if (newDate.getDate() !== oldDay) {
                onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
            }
            return newDate;
        });
    }
    function decrementHours() {
        setLocalDate(function (oldDate) {
            var oldDay = oldDate.getDate();
            var _a = dateToHMAM(oldDate), oldH = _a.hours, oldM = _a.minutes, oldAM = _a.isAM;
            var newHours = oldH - 1;
            var newIsAM = oldAM;
            if (newHours < 1) {
                newHours = 12;
            }
            var newDate = new Date(oldDate);
            // 12 -> 11 => flip AM/PM => possibly prev day
            if (oldH === 12 && newHours === 11) {
                newIsAM = !oldAM;
                if (oldAM) {
                    newDate.setDate(newDate.getDate() - 1);
                }
            }
            newDate = setHMAM(newDate, newHours, oldM, newIsAM);
            newDate = clampDate(newDate, minDate, maxDate);
            if (newDate.getDate() !== oldDay) {
                onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
            }
            return newDate;
        });
    }
    function incrementMinutes() {
        setLocalDate(function (oldDate) {
            var oldDay = oldDate.getDate();
            var _a = dateToHMAM(oldDate), oldH = _a.hours, oldM = _a.minutes, oldAM = _a.isAM;
            var newMinutes = oldM + 1;
            var newHours = oldH;
            var newIsAM = oldAM;
            var newDate = new Date(oldDate);
            if (newMinutes > 59) {
                newMinutes = 0;
                newHours += 1;
                if (newHours > 12)
                    newHours = 1;
                if (oldH === 11 && newHours === 12) {
                    newIsAM = !oldAM;
                    if (!oldAM) {
                        newDate.setDate(newDate.getDate() + 1);
                    }
                }
            }
            newDate = setHMAM(newDate, newHours, newMinutes, newIsAM);
            newDate = clampDate(newDate, minDate, maxDate);
            if (newDate.getDate() !== oldDay) {
                onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
            }
            return newDate;
        });
    }
    function decrementMinutes() {
        setLocalDate(function (oldDate) {
            var oldDay = oldDate.getDate();
            var _a = dateToHMAM(oldDate), oldH = _a.hours, oldM = _a.minutes, oldAM = _a.isAM;
            var newMinutes = oldM - 1;
            var newHours = oldH;
            var newIsAM = oldAM;
            var newDate = new Date(oldDate);
            if (newMinutes < 0) {
                newMinutes = 59;
                newHours -= 1;
                if (newHours < 1) {
                    newHours = 12;
                }
                if (oldH === 12 && newHours === 11) {
                    newIsAM = !oldAM;
                    if (oldAM) {
                        newDate.setDate(newDate.getDate() - 1);
                    }
                }
            }
            newDate = setHMAM(newDate, newHours, newMinutes, newIsAM);
            newDate = clampDate(newDate, minDate, maxDate);
            if (newDate.getDate() !== oldDay) {
                onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
            }
            return newDate;
        });
    }
    function handleHourChange(e) {
        var val = e.target.value.replace(/\D/g, '') || '1';
        var typedH = Math.max(1, Math.min(parseInt(val, 10), 12));
        setLocalDate(function (oldDate) {
            var newDate = new Date(oldDate);
            var _a = dateToHMAM(oldDate), oldM = _a.minutes, oldAM = _a.isAM;
            newDate = setHMAM(newDate, typedH, oldM, oldAM);
            newDate = clampDate(newDate, minDate, maxDate);
            return newDate;
        });
    }
    function handleMinuteChange(e) {
        var val = e.target.value.replace(/\D/g, '') || '0';
        var typedM = Math.max(0, Math.min(parseInt(val, 10), 59));
        setLocalDate(function (oldDate) {
            var newDate = new Date(oldDate);
            var _a = dateToHMAM(oldDate), oldH = _a.hours, oldAM = _a.isAM;
            newDate = setHMAM(newDate, oldH, typedM, oldAM);
            newDate = clampDate(newDate, minDate, maxDate);
            return newDate;
        });
    }
    function handleHoursBlur() {
        syncToParent();
    }
    function handleMinutesBlur() {
        syncToParent();
    }
    function toggleAMPM(nextIsAM) {
        setLocalDate(function (oldDate) {
            var _a = dateToHMAM(oldDate), oldH = _a.hours, oldM = _a.minutes;
            var newDate = setHMAM(oldDate, oldH, oldM, nextIsAM);
            newDate = clampDate(newDate, minDate, maxDate);
            onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
            return newDate;
        });
    }
    return (react_1.default.createElement("div", { className: "time-picker" },
        react_1.default.createElement("div", { className: "time-input" },
            react_1.default.createElement("button", { type: "button", onMouseDown: function () { return startHolding(hoursIncrementRef, incrementHours); }, onMouseUp: function () { return stopHolding(hoursIncrementRef); }, onMouseLeave: function () { return stopHolding(hoursIncrementRef); }, onTouchStart: function () { return startHolding(hoursIncrementRef, incrementHours); }, onTouchEnd: function () { return stopHolding(hoursIncrementRef); } },
                react_1.default.createElement("i", { className: "date-picker-icon implioicons-chevron-up" })),
            react_1.default.createElement("input", { type: "text", className: "form-control", value: hours.toString().padStart(2, '0'), onChange: handleHourChange, onBlur: handleHoursBlur, placeholder: "hh", pattern: "\\d*", inputMode: "numeric", "data-cy": "time-input-hours" }),
            react_1.default.createElement("button", { type: "button", onMouseDown: function () { return startHolding(hoursDecrementRef, decrementHours); }, onMouseUp: function () { return stopHolding(hoursDecrementRef); }, onMouseLeave: function () { return stopHolding(hoursDecrementRef); }, onTouchStart: function () { return startHolding(hoursDecrementRef, decrementHours); }, onTouchEnd: function () { return stopHolding(hoursDecrementRef); } },
                react_1.default.createElement("i", { className: "date-picker-icon implioicons-chevron-down" }))),
        react_1.default.createElement("span", { className: "time-separator" }, ":"),
        react_1.default.createElement("div", { className: "time-input" },
            react_1.default.createElement("button", { type: "button", onMouseDown: function () { return startHolding(minutesIncrementRef, incrementMinutes); }, onMouseUp: function () { return stopHolding(minutesIncrementRef); }, onMouseLeave: function () { return stopHolding(minutesIncrementRef); }, onTouchStart: function () { return startHolding(minutesIncrementRef, incrementMinutes); }, onTouchEnd: function () { return stopHolding(minutesIncrementRef); } },
                react_1.default.createElement("i", { className: "date-picker-icon implioicons-chevron-up" })),
            react_1.default.createElement("input", { type: "text", className: "form-control", value: minutes.toString().padStart(2, '0'), onChange: handleMinuteChange, onBlur: handleMinutesBlur, placeholder: "mm", pattern: "\\d*", inputMode: "numeric", "data-cy": "time-input-minutes" }),
            react_1.default.createElement("button", { type: "button", onMouseDown: function () { return startHolding(minutesDecrementRef, decrementMinutes); }, onMouseUp: function () { return stopHolding(minutesDecrementRef); }, onMouseLeave: function () { return stopHolding(minutesDecrementRef); }, onTouchStart: function () { return startHolding(minutesDecrementRef, decrementMinutes); }, onTouchEnd: function () { return stopHolding(minutesDecrementRef); } },
                react_1.default.createElement("i", { className: "date-picker-icon implioicons-chevron-down" }))),
        react_1.default.createElement("div", { className: "time-type" },
            react_1.default.createElement("button", { type: "button", className: "btn ".concat(isAM ? 'btn-primary' : ''), onClick: function () { return toggleAMPM(true); }, "data-cy": "time-input-AM" }, "AM"),
            react_1.default.createElement("button", { type: "button", className: "btn ".concat(!isAM ? 'btn-primary' : ''), onClick: function () { return toggleAMPM(false); }, "data-cy": "time-input-PM" }, "PM"))));
}
exports.TimePicker = TimePicker;
var clampDate = function (date, min, max) {
    var clamped = date;
    if (min && clamped < min) {
        clamped = min;
    }
    if (max && clamped > max) {
        clamped = max;
    }
    return clamped;
};
exports.DatePicker = react_1.default.memo(function (props) {
    var name = props.name, value = props.value, dateFormat = props.dateFormat, onChange = props.onChange, maxValue = props.maxValue, minValue = props.minValue, placeholder = props.placeholder, allowNull = props.allowNull, defaultRef = props.defaultRef, className = props.className, containerClassName = props.containerClassName, dataCy = props.dataCy, hideTime = props.hideTime;
    var _a = __read((0, react_1.useState)('date'), 2), view = _a[0], setView = _a[1];
    var yearsRef = react_1.default.useRef([]);
    var _b = __read(react_1.default.useState(''), 2), yearTitle = _b[0], setYearTitle = _b[1];
    var renderYearContent = function (year) {
        if (!yearsRef.current.includes(year) && yearsRef.current.length < 13) {
            yearsRef.current.push(year);
            yearsRef.current.sort(function (a, b) { return a - b; });
            var first = yearsRef.current[0];
            var last = yearsRef.current[yearsRef.current.length - 1];
            setYearTitle("".concat(first, " - ").concat(last));
        }
        return react_1.default.createElement("span", null, year);
    };
    var toggleView = function () {
        if (view === 'date') {
            setView('month');
        }
        if (view === 'month') {
            setView('year');
        }
        if (view === 'year') {
            setView('date');
        }
    };
    var isPreviousButtonEnabled = function (prevYearButtonDisabled, prevMonthButtonDisabled) {
        return (function () {
            if (view === 'date')
                return prevMonthButtonDisabled;
            if (view === 'month')
                return prevYearButtonDisabled;
            return Boolean(minValue && yearsRef.current[0] < minValue.getFullYear());
        })();
    };
    var isNextButtonEnabled = function (nextYearButtonDisabled, nextMonthButtonDisabled) {
        return (function () {
            if (view === 'date')
                return nextMonthButtonDisabled;
            if (view === 'month')
                return nextYearButtonDisabled;
            return Boolean(maxValue && yearsRef.current[yearsRef.current.length - 1] > maxValue.getFullYear());
        })();
    };
    return (react_1.default.createElement("div", { className: "input-wrap form-control ".concat(containerClassName), "data-cy": dataCy },
        react_1.default.createElement(react_datepicker_1.default, { onCalendarClose: function () { return setView('date'); }, name: name, dateFormat: dateFormat || 'dd/MM/yyyy hh:mm a', fixedHeight: true, selected: value, shouldCloseOnSelect: false, placeholderText: placeholder, isClearable: allowNull, renderYearContent: renderYearContent, onChange: function (pickedDate) {
                var newDate;
                if (view === 'date') {
                    // user has picked a day
                    newDate = pickedDate;
                }
                else if (view === 'month') {
                    // user has just picked a month
                    newDate = new Date(value || new Date());
                    newDate.setFullYear(pickedDate.getFullYear());
                    newDate.setMonth(pickedDate.getMonth());
                    setView('date');
                }
                else if (view === 'year') {
                    // user has just picked a year
                    newDate = new Date(value || new Date());
                    newDate.setFullYear(pickedDate.getFullYear());
                    setView('month');
                }
                var clampedDate = clampDate(newDate, minValue, maxValue);
                onChange(clampedDate);
            }, className: "form-control ".concat(className), showMonthYearPicker: view === 'month', showYearPicker: view === 'year', showTimeInput: !hideTime && view === 'date', maxDate: maxValue, minDate: minValue, timeInputLabel: "", clearButtonClassName: "implioicons-close", ref: defaultRef, customTimeInput: react_1.default.createElement(TimePicker, { onDateChange: onChange, minDate: minValue, maxDate: maxValue }), renderCustomHeader: function (_a) {
                var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, increaseYear = _a.increaseYear, decreaseYear = _a.decreaseYear, prevYearButtonDisabled = _a.prevYearButtonDisabled, nextYearButtonDisabled = _a.nextYearButtonDisabled, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("button", { type: "button", onClick: function () {
                            if (view === 'date') {
                                decreaseMonth();
                            }
                            else if (view === 'month') {
                                decreaseYear();
                            }
                            else if (view === 'year') {
                                yearsRef.current = [];
                                setYearTitle('');
                                decreaseYear();
                            }
                        }, disabled: isPreviousButtonEnabled(prevYearButtonDisabled, prevMonthButtonDisabled), className: "react-datepicker__navigation react-datepicker__navigation--previous" },
                        react_1.default.createElement("span", { className: "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" })),
                    react_1.default.createElement("h2", { onClick: toggleView, className: "react-datepicker-year-header" },
                        view === 'date' && date.toLocaleDateString(undefined, { month: 'long', year: 'numeric' }),
                        view === 'month' && date.toLocaleDateString(undefined, { year: 'numeric' }),
                        view === 'year' && yearTitle),
                    react_1.default.createElement("button", { type: "button", onClick: function () {
                            if (view === 'date') {
                                increaseMonth();
                            }
                            else if (view === 'month') {
                                increaseYear();
                            }
                            else if (view === 'year') {
                                yearsRef.current = [];
                                setYearTitle('');
                                increaseYear();
                            }
                        }, disabled: isNextButtonEnabled(nextYearButtonDisabled, nextMonthButtonDisabled), className: "react-datepicker__navigation react-datepicker__navigation--next" },
                        react_1.default.createElement("span", { className: "react-datepicker__navigation-icon react-datepicker__navigation-icon--next" }))));
            } })));
});
